<template>
    <v-snackbar
      :value="value != null ? value : snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ text }}
      <slot slot="button"></slot>
    </v-snackbar>
</template>


<script>    //v-focus="$attrs.focus ? $attrs.items : false"
    export default {
        props: {
            value: {
                type: Boolean,
                default: null,
            },
            x: {
                type: String,
                default: 'right'
            },
            y: {
                type: String,
                default: 'bottom'
            },
            timeout: {
                type: Number,
            },
            mode: {
                type: String,
            },
            text: {
                type: String,
            },
        },
        data() {
            return {
                snackbar: false,
            };
        },
        methods: {
            toggleSnackbar(value = null){
                // this.$store.commit('toggleGlobalSnackbar', value)
                this.snackbar = value != null ? value : !this.snackbar;
            }
        }
    };
</script>